import { Component, Input } from '@angular/core';

@Component({
    selector: 'emm-updated-date-display',
    templateUrl: './updated-date.component.html',
    styleUrls: ['./updated-date.component.scss'],
    standalone: false
})
export class UpdatedDateComponent {
    @Input() updatedDate: string | Date;
    @Input() updatedBy: string;
}
